import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { Card, ListGroup, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Cake, ClipboardClock, Send } from 'lucide-react';
import api from '../../api/api';
import Loading from '../../components/loading';
import { useNavigate } from 'react-router-dom';

export default function Reminders() {

  const navigate = useNavigate();

  const [reminders, setReminders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getAllReminders = useCallback(() => {
    setIsLoading(true);
    api.get('/reminders', {
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    }).then((returnFromApi) => {
      const processedReminders = returnFromApi.data.map(reminder => ({
        ...reminder,
        patientPhoneNumber: reminder.patientPhoneNumber
      }));

      setReminders(processedReminders);

    }).catch((returnFromApi) => {
      console.error('Erro ao buscar lembretes:', returnFromApi);
      if (returnFromApi.response && returnFromApi.response.status === 401) {
        navigate("/expired-session");
      }
    }).finally(() => {
      setIsLoading(false);
    });
  }, [navigate]);

  useEffect(() => {
    getAllReminders();
  }, [getAllReminders]);

  function removeInvalidCharacteresToWhatsApp(patientPhoneNumber) {
    return patientPhoneNumber.replace(/[()\s-]/g, '');
  }

  const appointmentWhatsApp = (reminder) => {
    const phoneNumber = removeInvalidCharacteresToWhatsApp(reminder.patientPhoneNumber);
    const message = `Olá! Gostaríamos de confirmar a sua consulta. Por favor, responda "SIM" para confirmar.`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
  };

  const birthdayWhatsApp = (reminder) => {
    const phoneNumber = removeInvalidCharacteresToWhatsApp(reminder.patientPhoneNumber);
    const message = `Parabéns! Desejamos um dia especial, cheio de alegrias e muitos sorrisos saudáveis!`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <Card className="bg-white rounded-4 shadow-lg border-0 card blurred">
      <Card.Header className="bg-white border-0 py-3">
        <h5 className="mb-0 fw-bold text-muted">Lembretes</h5>
      </Card.Header>

      <Loading isToHidden={isLoading === false} />

      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <ListGroup variant="flush">
          {reminders.map((reminder, index) => {
            const hasPhone = Boolean(reminder.patientPhoneNumber);

            const renderTooltip = (props) => (
              <Tooltip id={`tooltip-${reminder.id}`} {...props}>
                Paciente sem telefone cadastrado.
              </Tooltip>
            );

            return (
              <Fragment key={reminder.id}>
                <ListGroup.Item className="d-flex justify-content-between align-items-center py-3">

                  <div className="d-flex align-items-center">
                    {reminder.type === 'Próximas Consultas' ? (
                      <ClipboardClock className="me-3" size={20} />
                    ) : (
                      <Cake className="me-3" size={20} />
                    )}
                    <div>
                      <p className="mb-1 text-dark">
                        <span className="fw-bold">{reminder.title}</span>
                      </p>
                      <small className="text-muted">
                        {reminder.type}
                      </small>
                    </div>
                  </div>

                  <div>
                    {reminder.type === 'Próximas Consultas' ? (

                      <OverlayTrigger
                        placement="top"
                        overlay={!hasPhone ? renderTooltip : <div/>}
                      >
                        <span className="d-inline-block">
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => appointmentWhatsApp(reminder)}
                            disabled={!hasPhone}
                            style={!hasPhone ? { pointerEvents: 'none' } : {}}
                          >
                            <Send size={16} className="me-2" />
                            Confirmar Consulta por WhatsApp
                          </Button>
                        </span>
                      </OverlayTrigger>

                    ) : (

                      <OverlayTrigger
                        placement="top"
                        overlay={!hasPhone ? renderTooltip : <div/>}
                      >
                        <span className="d-inline-block">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => birthdayWhatsApp(reminder)}
                            disabled={!hasPhone}
                            style={!hasPhone ? { pointerEvents: 'none' } : {}}
                          >
                            <Send size={16} className="me-2" />
                            Enviar Felicitações por WhatAapp
                          </Button>
                        </span>
                      </OverlayTrigger>

                    )}
                  </div>
                </ListGroup.Item>
              </Fragment>
            )
          })}
        </ListGroup>
      </div>

      <Card.Body className="text-center py-5" hidden={reminders.length > 0}>
        <p className="text-muted mb-0">Nenhum lembrete para ser exibido no momento.</p>
      </Card.Body>

    </Card>
  );
}